module.exports = __webpack_public_path__ + "static/media/Urban Colors Art_1_t.ea3a3d57.jpg";